import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    description: 'Deep dark blue with cyan accents',
    preview: {
      bg: '#020410',
      card: '#0a0f1a',
      accent: '#06b6d4',
      text: '#f8fafc'
    }
  },
  slate: {
    id: 'slate',
    name: 'Slate',
    description: 'Professional grey tones',
    preview: {
      bg: '#0f172a',
      card: '#1e293b',
      accent: '#3b82f6',
      text: '#f1f5f9'
    }
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean',
    description: 'Calming blue depths',
    preview: {
      bg: '#082f49',
      card: '#0c4a6e',
      accent: '#22d3ee',
      text: '#f0f9ff'
    }
  },
  forest: {
    id: 'forest',
    name: 'Forest',
    description: 'Natural green tones',
    preview: {
      bg: '#052e16',
      card: '#14532d',
      accent: '#4ade80',
      text: '#f0fdf4'
    }
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset',
    description: 'Warm orange and purple',
    preview: {
      bg: '#1c1917',
      card: '#292524',
      accent: '#f97316',
      text: '#fafaf9'
    }
  },
  royal: {
    id: 'royal',
    name: 'Royal',
    description: 'Elegant purple theme',
    preview: {
      bg: '#1e1b4b',
      card: '#312e81',
      accent: '#a78bfa',
      text: '#f5f3ff'
    }
  },
  light: {
    id: 'light',
    name: 'Light',
    description: 'Clean light mode',
    preview: {
      bg: '#f8fafc',
      card: '#ffffff',
      accent: '#0ea5e9',
      text: '#0f172a'
    }
  },
  charcoal: {
    id: 'charcoal',
    name: 'Charcoal',
    description: 'Neutral dark grey',
    preview: {
      bg: '#18181b',
      card: '#27272a',
      accent: '#a1a1aa',
      text: '#fafafa'
    }
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('dj-crm-theme');
    return saved || 'midnight';
  });

  useEffect(() => {
    localStorage.setItem('dj-crm-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const value = {
    theme,
    setTheme,
    themes,
    currentTheme: themes[theme] || themes.midnight
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
